<template>
  <div>
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top shadow-sm w-100">
      <div class="container-fluid px-4">
        <a class="navbar-brand fw-bold text-success" href="#">Heritage Home</a>

        <!-- Toggler button -->
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Nav links -->
        <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link active" href="#about">About</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#services">Services</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#contact">Contact</a>
            </li>
             <li v-if="isLoggedIn">
              <a class="nav-link" href="/dashboard">Dashboard</a>
            </li>
            <li v-else class="nav-item">
              <a class="nav-link active" href="/login">login</a>
              <!-- <a href="/login" class="nav-link active">Login</a> -->
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Hero Section -->
    <section class="bg-success text-white text-center py-5 mt-5">
      <div class="container">
        <h1 class="display-5 fw-bold">Clean Homes, Cleaner Future</h1>
        <p class="lead">Community-based garbage collection by Heritage Children's Home in partinership with Sabaki residents association</p>
        <!-- <a href="/login" class="btn btn-light btn-lg mt-3">Admin</a> -->
         <a class="btn btn-light btn-lg mt-3" v-if="isLoggedIn">
          
              <a class="nav-link active" href="/dashboard">Dashboard</a>
         </a>
            <a v-else class="btn btn-light btn-lg mt-3">
              <a class="nav-link active" href="#contact">Become a client</a>
              <!-- <a href="/login" class="nav-link active">Login</a> -->
            </a>
      </div>
    </section>

    <!-- About Section -->
    <section id="about" class="py-5 bg-light">
      <div class="container text-center">
        <h2 class="fw-bold text-success">About Us</h2>
        <p class="mt-3">
          At Heritage Children's Home, we care for more than children. We extend our commitment to cleanliness and community service by offering affordable, dependable garbage collection services.
        </p>
      </div>
    </section>

    <!-- Services Section -->
    <section id="services" class="py-5">
      <div class="container">
        <h2 class="text-center fw-bold text-success mb-4">Our Services</h2>
        <div class="row g-4">
          <div class="col-md-4">
            <div class="border p-4 rounded shadow-sm h-100 text-center">
              <h5 class="fw-bold">Residential Collection</h5>
              <p>Scheduled waste pickup for homes and apartments.</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="border p-4 rounded shadow-sm h-100 text-center">
              <h5 class="fw-bold">Recycling Programs</h5>
              <p>Eco-conscious waste separation and recycling support.</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="border p-4 rounded shadow-sm h-100 text-center">
              <h5 class="fw-bold">Bulk Waste Removal</h5>
              <p>Pickup for large or heavy household or yard waste items.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section id="contact" class="py-5 bg-light">
      <div class="container">
      
  
    <h2>Enter your details here</h2>
    <p>Thsnk you for the interest to have your garbage collected by Heritage. Our Customer care representative will get  ack and onboard you. For help <strong>call 0728344248</strong> </p>
    <form @submit.prevent="createClient">
      <div class="form-control">
        <label for="name"> name </label>
        <input  class="form-control" type="text" id="client_name" v-model="formData.client_name" />
      </div>
      <div class="form-control"> 
        <label for="phone">phone </label>
        <input  class="form-control" type="text" id="phone" v-model="formData.phone" v-model.trim="formData.phone" />
      </div>
      <div class="form-control">
      <div class="field">
          <label class="label">court</label>
          <div class="select">
            <select v-model="formData.court">
              <option disabled value="">
                Select a court
              </option>
            
               <option  v-for="court in courts" :key="court.id">
         {{ court.courtId }} {{ court.name }}
      </option>
            </select>
          </div>
        </div>
        </div>
       
      <!-- <div class="form-control">
        <label for="registered_by"> reg by</label>
        <input type="text"  id="registered_by" v-model="formData.registered_by" />
      </div> -->
  
       
      
      <base-button>Submit</base-button>
      <br>
      <br>
      <router-link to="/">Go back Home</router-link>
    </form>
   
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-success text-white text-center py-3 mt-5">
      <small>&copy; 2025 Heritage Children's Home – All rights reserved.</small>
    </footer>
  </div>
</template>

<script>
  import axios from 'axios'

export default {
    computed: {
       isLoggedIn() {
         return this.$store.getters.isLoggedIn;
       },
           courts() {
              return  this.$store.getters.courts
  
              
          }
     },
   
     methods:{
       handleLogout() {
         this.$store.dispatch('clearToken')
         localStorage.removeItem('token') // clear your user's token from localstorage
         localStorage.removeItem('user') // clear your user from localstorage
   
         this.$router.push('/login')
   
       },
          async createClient(){
        const response = await axios.post("https://api.roberms.com/heritage/new/client/registration/", this.formData)
        console.log(response)
     
          this.$router.replace('/');
          console.log(this.formData)
  
      
  
      },
     },
     data(){
             return {
                  user: "",
                      formData: {
            client_name: '',
            phone: '',
            court:'',
              
              
              
  
          },
             }
        },
        
        mounted(){
             let user = localStorage.getItem('user')
             this.user = JSON.parse(user)
                   this.$store.dispatch('LoadCourts');  

        },
   }
   </script>